import { render, staticRenderFns } from "./KHRecord.vue?vue&type=template&id=4bbe9cc0&scoped=true&"
import script from "./KHRecord.vue?vue&type=script&lang=js&"
export * from "./KHRecord.vue?vue&type=script&lang=js&"
import style0 from "./KHRecord.vue?vue&type=style&index=0&id=4bbe9cc0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbe9cc0",
  null
  
)

export default component.exports